import $ from 'jquery';

// Open Listeners
$('.Header__right-button').on('click', function() {
  openModal($('.js-modal-login'));
});

$('.InternalTableOptions__button').on('click', function() {
  openModal($('.js-modal-recruitment'));
});

// Close Listeners
$('.js-modal-login .Modal__close').on('click', function() {
  closeModal($('.js-modal-login'));
});

$('.js-modal-recruitment .Modal__close').on('click', function() {
  closeModal($('.js-modal-recruitment'));
});

// Focus Trap Listener
$('.js-modal-login').on('keydown', ev => trapTabKey(ev, $('.js-modal-login')));

$('.js-modal-recruitment').on('keydown', ev =>
  trapTabKey(ev, $('.js-modal-recruitment'))
);

// Variables for focus
let lastFocusedElement = null;
let firstTabStop = null;
let lastTabStop = null;

/**
 *
 * @param {JQuery} modal
 */
function openModal(modal) {
  modal.fadeIn(300);

  const focusable_elements = modal.find(`
    a[href], area[href], input:not([disabled]), select:not([disabled]), 
    textarea:not([disabled]), button:not([disabled]), iframe, object, 
    embed, [tabindex="0"], [contenteditable]
  `);

  firstTabStop = focusable_elements[0];

  lastTabStop = focusable_elements[focusable_elements.length - 1];

  lastFocusedElement = document.activeElement;

  firstTabStop.focus();
}

/**
 *
 * @param {JQuery} modal
 */
function closeModal(modal) {
  modal.fadeOut(300);

  lastFocusedElement.focus();
}

/**
 *
 * @param {Event} ev
 * @param {JQuery} modal
 */
function trapTabKey(ev, modal) {
  if (ev.keyCode === 9) {
    // Shift + Tab
    if (ev.shiftKey) {
      if (document.activeElement === firstTabStop) {
        ev.preventDefault();
        lastTabStop.focus();
      }

      // Tab
    } else {
      if (document.activeElement === lastTabStop) {
        ev.preventDefault();
        firstTabStop.focus();
      }
    }
  }

  // Esc
  if (ev.keyCode === 27) {
    closeModal(modal);
  }
}
